import { MapItems, RawData } from "./state";

export type ListItem = {
  id: number | null;
  value: string;
  subItemOf: number | undefined;
  parentOf: number[];
};

export const INDEX_GROUPING = 0;
export const INDEX_PROCESS = 1;
export const INDEX_REASON = 2;
export const INDEX_STAKEHOLDER = 3;
export const INDEX_CODE = 4;

export enum ListToBeDisplayed {
  None,
  Process,
  Reason,
  Stakeholder,
  Breakdown
}

export function filterData(
  rawData: RawData,
  selectedGroupingId: number | null,
  selectedProcessId: number | null,
  selectedReasonId: number | null,
  selectedStakeholderId: number | null
): {
  groupings: MapItems;
  processes: MapItems;
  reasons: MapItems;
  stakeholders: MapItems;
} {
  const groupings: MapItems = {};
  const processes: MapItems = {};
  const reasons: MapItems = {};
  const stakeholders: MapItems = {};

  rawData.data.forEach(elem => {
    if (
      (selectedProcessId !== null
        ? elem[INDEX_PROCESS] == selectedProcessId
        : true) &&
      (selectedReasonId !== null
        ? elem[INDEX_REASON] == selectedReasonId
        : true) &&
      (selectedStakeholderId !== null
        ? elem[INDEX_STAKEHOLDER] == selectedStakeholderId
        : true)
    ) {
      groupings[elem[INDEX_GROUPING]] = rawData.groupings[elem[INDEX_GROUPING]];
    }

    if (
      (selectedGroupingId !== null
        ? elem[INDEX_GROUPING] == selectedGroupingId
        : true) &&
      (selectedReasonId !== null
        ? elem[INDEX_REASON] == selectedReasonId
        : true) &&
      (selectedStakeholderId !== null
        ? elem[INDEX_STAKEHOLDER] == selectedStakeholderId
        : true)
    ) {
      processes[elem[INDEX_PROCESS]] = rawData.processes[elem[INDEX_PROCESS]];
    }

    if (
      (selectedGroupingId !== null
        ? elem[INDEX_GROUPING] == selectedGroupingId
        : true) &&
      (selectedProcessId !== null
        ? elem[INDEX_PROCESS] == selectedProcessId
        : true) &&
      (selectedStakeholderId !== null
        ? elem[INDEX_STAKEHOLDER] == selectedStakeholderId
        : true)
    ) {
      reasons[elem[INDEX_REASON]] = rawData.reasons[elem[INDEX_REASON]];
    }

    if (
      (selectedGroupingId !== null
        ? elem[INDEX_GROUPING] == selectedGroupingId
        : true) &&
      (selectedProcessId !== null
        ? elem[INDEX_PROCESS] == selectedProcessId
        : true) &&
      (selectedReasonId !== null
        ? elem[INDEX_REASON] == selectedReasonId
        : true)
    ) {
      stakeholders[elem[INDEX_STAKEHOLDER]] =
        rawData.stakeholders[elem[INDEX_STAKEHOLDER]];
      const subStakeholderId = rawData.subStakeholders[elem[INDEX_STAKEHOLDER]];
      if (subStakeholderId !== undefined) {
        stakeholders[subStakeholderId] = rawData.stakeholders[subStakeholderId];
      }
    }
  });

  return {
    groupings: groupings,
    processes: processes,
    reasons: reasons,
    stakeholders: stakeholders
  };
}
